import logo from '../../Assets/Images/rklogo.png'
import React from 'react'
import { motion } from 'framer-motion'
import { BsCheckCircleFill } from 'react-icons/bs'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FieldInput from '../../Components/FieldInput'
import Button from '../../Components/Button'
import { useHistory } from 'react-router-dom'
import API from '../../Common/API'
import { useDispatch, useSelector } from 'react-redux'
import { setLoggedIn, setUserDetails, setToken, setAccountType } from '../../Store/Auth/actions'
import { useTranslation } from 'react-i18next'
import { setAlert } from '../../Store/Theme/actions'

const initialLoginForm = {
    userName: '',
    password: '',
}

const Login = () => {

    const history = useHistory()
    const dispatch = useDispatch()
    const sellerCreation = useSelector((state) => state.auth.sellerCreation)
    const { t } = useTranslation()

    const loginFormSchema = Yup.object().shape({
        userName: Yup.string().required("User Name is required"),
        password: Yup.string().required("Password is required"),
    })

    const loginForm = useFormik({
        initialValues: initialLoginForm,
        validateOnMount: true,
        validationSchema: loginFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            API.post('/auth/login', values).then(async (loginRes) => {
                if (loginRes.status === 200) {
                    localStorage.setItem('token', loginRes.data.data)
                    let userDetails = await JSON.parse(window.atob(loginRes.data.data.split(".")[1]));
                    console.log(userDetails)
                    if (userDetails.subject.accountType !== 'seller') {
                        dispatch(setUserDetails(userDetails))
                        dispatch(setAccountType('user'))
                        dispatch(setToken(loginRes.data.data))
                        dispatch(setLoggedIn(true))
                        if (sellerCreation) {
                            history.push('/createSellerAccount')
                        } else {
                            history.push('/')
                        }
                    } else if (userDetails.subject.accountType === 'seller' && userDetails.subject.status === 'Approve') {
                        dispatch(setUserDetails(userDetails))
                        dispatch(setAccountType(userDetails.subject.accountType))
                        dispatch(setToken(loginRes.data.data))
                        dispatch(setLoggedIn(true))
                        history.push(`/store/${userDetails.subject.sellerId}/`)
                    } else {
                        dispatch(setAlert({ title: 'Info', subtitle: 'Your account is under verification. Please try again later.', active: true, type: 'info' }))
                    }
                }
            }).catch((err) => {
                dispatch(setAlert({ title: 'Error', subtitle: err.response.data.error, active: true, type: 'error' }))
            })
        }
    })


    return (
        <div className="w-full h-screen flex items-center justify-center">
            <div className="w-1/2 hidden lg:inline-flex h-full text-black">
                <div className="w-[450px] h-full bg-primeColor/20 px-10 flex flex-col gap-6 justify-center">
                    <img src={logo} alt="logoImg" className="w-28" onClick={() => history.push('/')} />
                    <div className="flex flex-col gap-1 -mt-1">
                        <h1 className="font-titleFont text-xl font-medium">
                            {t('Stay sign in for more')}
                        </h1>
                        <p className="text-base">{t('When you sign in, you are with us!')}</p>
                    </div>
                    <div className="w-[300px] flex items-start gap-3">
                        <span className="text-green-500 mt-1">
                            <BsCheckCircleFill />
                        </span>
                        <p className="text-base text-gray-300">
                            <span className="text-black font-semibold font-titleFont">
                                {t('Get started fast with Royalkavery')}
                            </span>
                            <br />
                        </p>
                    </div>
                    <div className="w-[300px] flex items-start gap-3">
                        <span className="text-green-500 mt-1">
                            <BsCheckCircleFill />
                        </span>
                        <p className="text-base text-gray-300">
                            <span className="text-black font-semibold font-titleFont">
                                {t('Access all Royalkavery services')}
                            </span>
                            <br />
                        </p>
                    </div>
                    <div className="w-[300px] flex items-start gap-3">
                        <span className="text-green-500 mt-1">
                            <BsCheckCircleFill />
                        </span>
                        <p className="text-base text-gray-300">
                            <span className="text-black font-semibold font-titleFont">
                                {t('Trusted by online Shoppers')}
                            </span>
                            <br />
                        </p>
                    </div>
                    <div className="flex items-center justify-between mt-10">
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            © Royalkavery
                        </p>
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            {t('Terms')}
                        </p>
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            {t('Privacy')}
                        </p>
                        <p className="text-sm font-titleFont font-semibold text-black-200 hover:text-black cursor-pointer duration-300">
                            {t('Security')}
                        </p>
                    </div>
                </div>
            </div>
            <div className="w-full md:w-1/2 grid grid-cols-1 gap-10 items-center justify-center">
                <motion.div className="w-full md:w-80 flex flex-col cursor-pointer items-center justify-center" onClick={() => history.push('/')}>
                    <img src={logo} height={100} width={100} alt="logo" onClick={() => history.push('/')} />
                </motion.div>
                <motion.div className="grid grid-cols-1 w-96">
                    <FieldInput label={t("Registered Mobile/Email Id")} placeholder={t("Registered Mobile/Email Id")} fieldProps={loginForm.getFieldProps('userName')} fieldHelper={loginForm.getFieldHelpers('userName')} fieldMeta={loginForm.getFieldMeta('userName')} edit={true} dataLoaded={true} />
                    <FieldInput label={t("Password")} placeholder={t("Password")} type="password" fieldProps={loginForm.getFieldProps('password')} fieldHelper={loginForm.getFieldHelpers('password')} fieldMeta={loginForm.getFieldMeta('password')} edit={true} dataLoaded={true} />
                    <a className='flex flex-row justify-end underline cursor-pointer' onClick={()=>history.push('/auth/forgotPassword')}>Forgot password</a>
                    <Button injectClass={'bg-primaryColor ring-[black] rounded-xl cursor-pointer'} onClick={() => loginForm.submitForm()}>{t('Login')}</Button>
                    <motion.div className='text-md items-center justify-center flex flex-col'>
                        <p>{t('New to the platform')}?</p>&nbsp;
                        <Button injectClass={'bg-primaryColor ring-[black] rounded-xl cursor-pointer'} onClick={() => history.push('/auth/signUp')}>{t('Register Here')}</Button>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    )
}

export default Login